exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.task-menu-popup{position:fixed;left:0;top:0;width:100vw;height:100vh;z-index:25;background-color:transparent}.task-menu-popup .task-menu-overlay{position:absolute;border-radius:4px;background-color:#fff;box-shadow:0 1px 3px 0 rgba(0,0,0,.25);width:200px;height:100%;min-height:120px;max-height:150px;border:2px solid #184e78}.task-menu-popup .task-menu-overlay .menu-open-indicator{position:absolute;width:0;height:0;border-left:0 solid transparent;border-right:16px solid transparent;border-top:16px solid #184e78}.task-menu-popup .task-menu-overlay .menu-popout{position:absolute;left:206px;top:4px;width:86px}.task-menu-popup .task-menu-overlay .menu-popout .menu-item{width:100%;height:24px;margin-bottom:6px;background-color:#184e78;font-family:Open Sans,sans-serif;font-size:12px;font-weight:700;line-height:24px;padding-left:4px;color:#fff;cursor:pointer;transition:transform 85ms ease-in}.task-menu-popup .task-menu-overlay .menu-popout .menu-item:hover{transform:translateX(5px)}.task-menu-popup .task-menu-overlay .menu-popout .menu-item--left:hover{transform:translateX(-5px)}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/TaskMenuPopup/TaskMenuPopup.scss
// module id = 1668
// module chunks = 0